export default __webpack_public_path__ + "static/media/Action-Dots.8572dc15.svg";